export enum SkillLevelEnum {
	AllLevels = 0,
	Beginner = 1,
	Intermediate = 2,
	Advanced = 3,
}
